import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityIndicators = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encryption',
      description: 'All data is encrypted using 256-bit SSL technology',
      status: 'active'
    },
    {
      icon: 'Lock',
      title: 'Secure Processing',
      description: 'PCI DSS compliant payment processing',
      status: 'active'
    },
    {
      icon: 'Eye',
      title: 'Fraud Protection',
      description: 'Advanced fraud detection and prevention',
      status: 'active'
    },
    {
      icon: 'CheckCircle',
      title: 'Marketplace Guarantee',
      description: 'Protected by AutoCasse buyer protection',
      status: 'active'
    }
  ];

  const certifications = [
    {
      name: 'PCI DSS',
      description: 'Payment Card Industry Data Security Standard',
      icon: 'CreditCard'
    },
    {
      name: 'SSL Certificate',
      description: 'Verified by trusted certificate authority',
      icon: 'Shield'
    },
    {
      name: 'ISO 27001',
      description: 'Information security management certified',
      icon: 'Award'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-soft">
      <div className="flex items-center space-x-2 mb-6">
        <Icon name="Shield" size={20} className="text-success" />
        <h2 className="text-lg font-semibold text-foreground">Security & Protection</h2>
      </div>
      {/* Security Features */}
      <div className="space-y-4 mb-6">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3 p-3 bg-success/5 border border-success/20 rounded-lg">
            <div className="w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={feature?.icon} size={16} className="text-success" />
            </div>
            <div className="flex-1">
              <div className="flex items-center space-x-2">
                <h3 className="font-medium text-foreground">{feature?.title}</h3>
                <div className="w-2 h-2 bg-success rounded-full animate-pulse-soft"></div>
              </div>
              <p className="text-sm text-muted-foreground mt-1">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
      {/* Trust Badges */}
      <div className="border-t border-border pt-6">
        <h3 className="text-sm font-medium text-foreground mb-4">Certifications & Compliance</h3>
        <div className="grid grid-cols-1 gap-3">
          {certifications?.map((cert, index) => (
            <div key={index} className="flex items-center space-x-3 p-3 bg-muted/30 rounded-lg">
              <Icon name={cert?.icon} size={16} className="text-primary" />
              <div>
                <div className="font-medium text-foreground text-sm">{cert?.name}</div>
                <div className="text-xs text-muted-foreground">{cert?.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Guarantee Information */}
      <div className="mt-6 p-4 bg-primary/5 border border-primary/20 rounded-lg">
        <div className="flex items-start space-x-2">
          <Icon name="ShieldCheck" size={20} className="text-primary mt-0.5" />
          <div>
            <h4 className="font-medium text-primary mb-1">AutoCasse Protection</h4>
            <p className="text-sm text-muted-foreground">
              Your payment is protected by our marketplace guarantee. 
              If there's an issue with your transaction, we'll help resolve it 
              or provide a full refund within 30 days.
            </p>
          </div>
        </div>
      </div>
      {/* Contact Security Team */}
      <div className="mt-4 text-center">
        <p className="text-xs text-muted-foreground mb-2">
          Questions about security?
        </p>
        <button className="text-xs text-primary hover:underline">
          Contact our security team
        </button>
      </div>
    </div>
  );
};

export default SecurityIndicators;